class Common {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){

    let scrollTimeout;

    if($('.p-recruit').length) {
      $('html').addClass('is-menu');
    } else {

      // ページロード時にスクロール位置を確認
      if ($(window).scrollTop() > 10) {
        $('html').addClass('is-menu');
      } else {
        $('html').removeClass('is-menu');
      }
      
      $(window).on('scroll', function() {
        clearTimeout(scrollTimeout);
  
        scrollTimeout = setTimeout(function() {
          if ($(window).scrollTop() > 10) {
            $('html').addClass('is-menu');
          } else {
            $('html').removeClass('is-menu');
          }
        }, 100);
      });
    }

    $('.js-drawer').on('click touchstart', function() {
      $('html').toggleClass('is-drawer');
    });


    
    
  }
}